<template>
    <ExternalQueryList
        endpoint="/api/v2/tags"
        :headlines="headlines"
        :filters="filters"
        :can-destroy="() => true"
        :can-update="() => true"
        @show="tag => $router.push(getUrl(tag))"
    >
        <template v-slot:default="{ row: tag }">
            <td>
                <router-link :to="getUrl(tag)">
                    {{ tag.attributes.name }}
                </router-link>
            </td>

            <td>
                <span class="label" :style="{'background-color': tag.attributes.color}">
                    {{ tag.attributes.name }}
                </span>
            </td>
        </template>
    </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
    components: {ExternalQueryList},

    computed: {
        headlines() {
            return [
                {width: 11, text: 'Name'},
                {width: 11, text: 'Appearance'}
            ]
        },

        filters() {
            return [
                [
                    {
                        width: 20,
                        widget: 'text',
                        name: 'search',
                        placeholder: 'Search...'
                    },
                    {
                        width: 4,
                        widget: 'submit'
                    }
                ]
            ]
        }
    },

    methods: {
        getUrl(tag) {
            return '/tags/' + tag.id + '/edit'
        }
    }
}
</script>
